import CoursePriceTable from './CoursePriceTable'

export default CoursePriceTable
